export { default } from './mobile-web-landing';

